(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-articles-by-tag"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function bind(root) {
      var btn = root.querySelector('.related-articles__toggle');
      if (!btn || btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';

      var list = root.querySelector('.related-articles__list');
      var labelEl = btn.querySelector('.related-articles__toggle-label');
      var showText = btn.getAttribute('data-show-label');
      var hideText = btn.getAttribute('data-hide-label');
      if (!list || !labelEl) return;

      btn.addEventListener('click', function() {
        var expanded = list.getAttribute('data-expanded') === 'true';
        var next = expanded ? 'false' : 'true';
        list.setAttribute('data-expanded', next);
        btn.setAttribute('aria-expanded', next);
        labelEl.textContent = expanded ? showText : hideText;
      });
    }

    function initAll() {
      document.querySelectorAll('.related-articles-by-tag').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target.querySelector('.related-articles-by-tag');
      if (root) bind(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
